/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
export const GET_SERVER_TIME = "GET_SERVER_TIME";
export const GET_SERVER_TIME_SUCCESS = "GET_SERVER_TIME_SUCCESS";
export const GET_SERVER_TIME_FAILURE = "GET_SERVER_TIME_FAILURE";
